/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_Ai_DescInputs */

const en_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`European AI, built in Paris.`)
};

const de_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europaeische KI, gebaut in Paris.`)
};

const fr_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA européenne, conçue à Paris.`)
};

const es_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA europea, creada en París.`)
};

const it_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI europea, creata a Parigi.`)
};

const nl_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europese AI, gebouwd in Parijs.`)
};

const pl_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europejskie AI, zbudowane w Paryżu.`)
};

const fi_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eurooppalainen tekoäly, rakennettu Pariisissa.`)
};

const da_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europæisk AI, bygget i Paris.`)
};

const sv_landing_trust_ai_desc = /** @type {(inputs: Landing_Trust_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europeisk AI, byggd i Paris.`)
};

/**
* | output |
* | --- |
* | "European AI, built in Paris." |
*
* @param {Landing_Trust_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_ai_desc = /** @type {((inputs?: Landing_Trust_Ai_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_Ai_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_ai_desc(inputs)
	if (locale === "fr") return fr_landing_trust_ai_desc(inputs)
	if (locale === "es") return es_landing_trust_ai_desc(inputs)
	if (locale === "it") return it_landing_trust_ai_desc(inputs)
	if (locale === "nl") return nl_landing_trust_ai_desc(inputs)
	if (locale === "pl") return pl_landing_trust_ai_desc(inputs)
	if (locale === "fi") return fi_landing_trust_ai_desc(inputs)
	if (locale === "da") return da_landing_trust_ai_desc(inputs)
	if (locale === "sv") return sv_landing_trust_ai_desc(inputs)
	return en_landing_trust_ai_desc(inputs)
});